import AppointmentList from './appointmentsList';
import enhance from './AppointmentsListContainer';

export default enhance(AppointmentList);
